export const INPUT_STEP_NAMES = {
    location: 'location',
    numbers: 'numbers',
    housing: 'housing',
    simulation: 'simulation',
    empty: 'empty',
}

export const INPUT_STEPS = {
    location: { index: 0, key: 'location', name: 'Your Location' },
    numbers: { index: 1, key: 'numbers', name: 'Your Numbers' },
    housing: { index: 2, key: 'housing', name: 'Housing Dates' },
    simulation: { index: 3, key: 'simulation', name: 'Simulation Dates' },
    empty: { index: 4, key: 'empty', name: 'Empty Date' },
}

export const INPUT_NAMES = {
    date_in: 'Date In',
    date_out: 'Date Out',
    digest_energy: 'Digestible Energy',
    date_empty: 'Empty Date',
    milk_yield: 'Milk Yield',
    n_cows: 'Number of Cows',
    postcode: 'Postcode',
    sim_end_date: 'Simulation End Date',
    sim_start_date: 'Simulation Start Date',
}
